export class CashCreditRequest {
    amount: number;
    tenure: number;
    emi: number;
}

export class CashCreditPricing {
    BasketAmount: number;
    EmiOptions: CashCreditEmi[];
}

export class CashCreditEmi {
    IsDefault: boolean;
    NumberOfMonths: number;
    TotalMonthlyAmount: number;
    InterestAmount: number;
    InterestFreeMonths: number;
    LoanAmount: number;
    DownpaymentAmount: number;
    ProcessingFee: number;
    ProcessingFeeRate: number;
    DownpaymentRate: number;
    InterestRate: number;
}

export class PersonalLoanPricingCap {
    CustomerConfig: any[];
    CustomerId: string;
    MinLoanAmount: number;
    MaxLoanAmount: number;
    Type: string;
}

export class PersonalLoanPricingEmiOptions {
    BasketAmount: number;
    EmiOptions: EmiOption[];
}

export class EmiOption {
    IsDefault: boolean;
    NumberOfMonths: number;
    TotalMonthlyAmount: number;
    InterestAmount: number;
    InterestFreeMonths: number;
    LoanAmount: number;
    DownpaymentAmount: number;
    ProcessingFee: number;
    ProcessingFeeRate: number;
    DownpaymentRate: number;
    SubventionInterestCashback: boolean;
    InterestRate: number;
    EffectiveEmiAmount: number;
    SchemeId: number;
    InterestScheduleType: string;
    AdvanceEMITenure: number;
}
